<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->

<h1>{{title}}
  <span class="mdi mdi-information-outline info-icon"
        matTooltip="Subscription ID: {{subscription.subscription_id}}"
        matTooltipPosition="after">
  </span>
  <span class="subscription-ratio">
    ({{licensesUsed | number}}/{{subscription.count | number}})
  </span>
</h1>
<div class="heading">
    <div class="invisible-card">
        <h3>Subscription</h3>
        <hr>
        <div>
            <div>{{'products.sub-type' | translate}}</div>
            <ng-container [ngSwitch]="subscription.type">
                <ng-container *ngSwitchCase="LicenseType.LICENSE_TYPE_TIME_LIMITED">
                    <div>{{'TIME_LIMITED' | translate}}</div>
                </ng-container>
                <ng-container *ngSwitchCase="LicenseType.LICENSE_TYPE_FREE">
                    <div>{{'D3E_FREE' | translate}}</div>
                </ng-container>
                <ng-container *ngSwitchCase="LicenseType.LICENSE_TYPE_PERPETUAL">
                    <div>{{'PERPETUAL' | translate}}</div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div>{{'unknown' | translate}}</div>
                </ng-container>
            </ng-container>
        </div>
        <div>
            <div>{{'products.sub-expiration' | translate}}</div>
            <ng-container *ngIf="isUnlimited(subscription.exp_timestamp); else haveExpTimestamp">
                <div>{{'NEVER' | translate}}</div>
            </ng-container>
            <ng-template #haveExpTimestamp>
                <div>{{subscription.exp_timestamp | date}}</div>
            </ng-template>
        </div>
        <div>
            <div>{{'products.maintenance' | translate}}</div>
            <ng-container *ngIf="isUnlimited(subscription.maint_exp_timestamp); else haveMaintenanceTimestamp">
                <div>{{'NEVER' | translate}}</div>
            </ng-container>
            <ng-template #haveMaintenanceTimestamp>
                <div>{{subscription.maint_exp_timestamp | date}}</div>
            </ng-template>
        </div>
    </div>
    <div class="invisible-card">
      <div class="h3-spacer">
      </div>
      <hr>
      <div>
        <a [routerLink]="['/downloads']" [queryParams]="{subscriptionId: subscription.subscription_id}">{{'products.download-software' | translate}}</a>
      </div>
    </div>
    <div class="invisible-card">
    </div>
</div>
